import barba from '@barba/core';

export default class CapeBarba {
    constructor() {
        if ($('#layout-content').length) {
            this.init();
        }
    }

    init() {
        var scrollPosY = 0;
        history.scrollRestoration = "manual";

        $('.smooth-show').addClass('show');
        barba.init({
            timeout: 30000,
            cacheIgnore: true,
            transitions: [{
                name: 'default-transition',
                leave() {
                    window.showLoader();
                },
                enter(data) {
                    if(data.trigger !== "back") {
                        scrollPosY = barba.history.current.scroll.y;
                    }
                    
                    window.hideLoader(true);
                    window.initJS.init();
                    $('body').removeClass('scrolled');
                    $('body').removeClass('menu-open');
                },

                afterLeave(data) {
                    let namespace = $(data.next.container).data('barba-namespace');
                    $('body').attr('data-page', namespace);
                    $('.input-search').removeClass('show');
                },

                after(data) {
                    if(data.trigger !== "back") {
                        window.scrollTo(0,0);
                    } else {
                        window.scrollTo(0, scrollPosY)
                    }
                },

                afterEnter(data) {
                    let $newPageHead = $('<head />').html(
                        $.parseHTML(
                            data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0]
                            , document
                            , true
                        )
                    );
                    let headTags = [
                        "meta[name='keywords']",
                        "meta[name='description']",
                        "meta[name='robots']",
                        "meta[property^='og']",
                        "meta[name^='twitter']",
                        "meta[itemprop]",
                        "link[itemprop]",
                        "link[rel='prev']",
                        "link[rel='next']",
                        "link[rel='canonical']"
                    ].join(',');
                    $('head').find(headTags).remove(); // Remove current head tags
                    $newPageHead.find(headTags).appendTo('head'); // Append new tags to the head
                }
            }]
        });
    }
}
